/**
 * スクロールアニメーションを制御するクラス
 * data-animation属性を持つ要素を監視し、画面に表示されたらtrueに設定
 */

export default class ScrollAnimation {
  constructor(options = {}) {
    // 監視対象のセレクタ
    this.selector = options.selector || '[data-animation]';
    // Intersection Observerのオプション
    this.observerOptions = {
      root: options.root || null,
      rootMargin: options.rootMargin || '0px',
      threshold: options.threshold || 0.3, // 監視対象要素が画面に○%表示されたらアニメーションを実行
      ...options.observerOptions
    };
    // 一度だけアニメーションを実行するか（デフォルト: true）
    this.once = options.once !== undefined ? options.once : true;
    this.observer = null;
  }

  /**
   * 要素がビューポートに入ったときのコールバック
   */
  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 要素が画面に入ったらdata-animationをtrueに設定
        entry.target.setAttribute('data-animation', 'true');

        // onceがtrueの場合、一度アニメーションが実行されたら監視を解除
        if (this.once) {
          this.observer.unobserve(entry.target);
        }
      } else if (!this.once) {
        // onceがfalseの場合、画面から出たらfalseに戻す
        entry.target.setAttribute('data-animation', 'false');
      }
    });
  }

  /**
   * 初期化処理
   */
  init() {
    // 監視対象の要素を取得
    const targets = document.querySelectorAll(this.selector);

    if (targets.length === 0) {
      return;
    }

    // Intersection Observerのインスタンスを作成
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      this.observerOptions
    );

    // 各要素を監視開始
    targets.forEach((target) => {
      // 初期値をfalseに設定（まだ設定されていない場合）
      if (!target.hasAttribute('data-animation')) {
        target.setAttribute('data-animation', 'false');
      }
      this.observer.observe(target);
    });
  }

  /**
   * 破棄処理
   */
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

